// @ utils
const { APIPost, APIGet } = require('utilities/APIRequestHelper');
const { getLanguage } = require('core/i18n').i18n;

// @ actions
const { requestInsuranceRelatedCurrentState } = require('./insuranceRequestRelatedState');
const { mortgageRequestInsurancesLink } = require('actions/mortgageRequest/mortgageRequestManagerInsuranceRelated');

// @ constants
const { SECOND_STEP, THIRD_STEP } = require('constants/index');
const { PLANS: { HIGH, BASIC, MEDIUM }, COVERAGES_NAMES } = require('../../insuranceConstants/insuranceRequestHome');
const { INSURANCES_TYPE: { HOME_MORTGAGE_RELATED } } = require('../../insuranceConstants/insuranceRequestTypes');

const {
    INSURANCE_REQUEST_RELATED_SIMULATION_LINK_S3_CLIENT_REQUEST,
    INSURANCE_REQUEST_RELATED_SIMULATION_LINK_S3_CLIENT_SUCCESS,
    INSURANCE_REQUEST_RELATED_SIMULATION_LINK_S3_CLIENT_FAILURE,
    INSURANCE_REQUEST_RELATED_COVERAGES_QUOTATION_REQUEST,
    INSURANCE_REQUEST_RELATED_COVERAGES_QUOTATION_SUCCESS,
    INSURANCE_REQUEST_RELATED_COVERAGES_QUOTATION_FAILURE,
    INSURANCE_REQUEST_RELATED_SELECT_PLAN_SUCCESS,
    INSURANCE_REQUEST_RELATED_SELECT_PLAN_REQUEST,
    INSURANCE_REQUEST_RELATED_SELECT_PLAN_FAILURE,
    INSURANCE_REQUEST_RELATED_GET_COVERAGES_AND_PLANS_TABLE_REQUEST,
    INSURANCE_REQUEST_RELATED_GET_COVERAGES_AND_PLANS_TABLE_SUCCESS,
    INSURANCE_REQUEST_RELATED_GET_COVERAGES_AND_PLANS_TABLE_FAILURE,
    INSURANCE_REQUEST_RELATED_COVERAGES_DETAIL_BASIC_DATA_REQUEST,
    INSURANCE_REQUEST_RELATED_COVERAGES_DETAIL_BASIC_DATA_SUCCESS,
    INSURANCE_REQUEST_RELATED_COVERAGES_DETAIL_MEDIUM_DATA_REQUEST,
    INSURANCE_REQUEST_RELATED_COVERAGES_DETAIL_MEDIUM_DATA_SUCCESS,
    INSURANCE_REQUEST_RELATED_COVERAGES_DETAIL_HIGH_DATA_REQUEST,
    INSURANCE_REQUEST_RELATED_COVERAGES_DETAIL_HIGH_DATA_SUCCESS,
    INSURANCE_REQUEST_RELATED_COVERAGES_DETAIL_DATA_FAILURE,
    INSURANCE_REQUEST_RELATED_SELECTED_PLAN,
    INSURANCE_REQUEST_RELATED_SET_LINKING_SUCCESS_TO_INITIAL,
    INSURANCE_REQUEST_RELATED_SIMULATION_LINK_S3_CLIENT_INITIAL_VALUE_IN_SUCCESS,
    INSURANCE_REQUEST_SELECT_BASIC_PLAN,
} = require('../../insuranceConstants/actionTypes');
const {
    PRE_CONTRACTUAL_RELATED_INSURANCE_MAIL,
    INSURANCE_USABILITY_IMPROVEMENTS,
} = require('constants/flagBasedFeatures');

const linkClientInProgress = () => ({
    type: INSURANCE_REQUEST_RELATED_SIMULATION_LINK_S3_CLIENT_REQUEST
});

const linkClientSuccess = () => ({
    type: INSURANCE_REQUEST_RELATED_SIMULATION_LINK_S3_CLIENT_SUCCESS
});

const linkClientFailure = error => ({
    type: INSURANCE_REQUEST_RELATED_SIMULATION_LINK_S3_CLIENT_FAILURE,
    data: { error }
});

const setLinkedSimulationToInitial = () => ({
    type: INSURANCE_REQUEST_RELATED_SET_LINKING_SUCCESS_TO_INITIAL,
});

const requestQuotationInProgress = (quotationRequestId) => ({
    type: INSURANCE_REQUEST_RELATED_COVERAGES_QUOTATION_REQUEST,
    data: { quotationRequestId }
});

const requestQuotationSuccess = data => ({
    type: INSURANCE_REQUEST_RELATED_COVERAGES_QUOTATION_SUCCESS,
    data
});

const requestQuotationFailure = error => ({
    type: INSURANCE_REQUEST_RELATED_COVERAGES_QUOTATION_FAILURE,
    data: { error }
});

const requestSelectPlanSuccess = plan => ({
    type: INSURANCE_REQUEST_RELATED_SELECT_PLAN_SUCCESS,
    data: {
        plan
    }
});

const requestSelectPlanInProgress = () => ({
    type: INSURANCE_REQUEST_RELATED_SELECT_PLAN_REQUEST
});

const requestSelectPlanFailure = error => ({
    type: INSURANCE_REQUEST_RELATED_SELECT_PLAN_FAILURE,
    data: { error }
});

const coveragesAndPlansDataInProgress = () => ({
    type: INSURANCE_REQUEST_RELATED_GET_COVERAGES_AND_PLANS_TABLE_REQUEST
});

const coveragesAndPlansDataSuccess = data => ({
    type: INSURANCE_REQUEST_RELATED_GET_COVERAGES_AND_PLANS_TABLE_SUCCESS,
    data
});

const coveragesAndPlansDataFailure = error => ({
    type: INSURANCE_REQUEST_RELATED_GET_COVERAGES_AND_PLANS_TABLE_FAILURE,
    data: { error }
});

const coveragesAndPlansDetailsBasicInProgress = () => ({
    type: INSURANCE_REQUEST_RELATED_COVERAGES_DETAIL_BASIC_DATA_REQUEST,
});

const coveragesAndPlansDetailsBasicSuccess = data => ({
    type: INSURANCE_REQUEST_RELATED_COVERAGES_DETAIL_BASIC_DATA_SUCCESS,
    data
});

const coveragesAndPlansDetailsMediumInProgress = () => ({
    type: INSURANCE_REQUEST_RELATED_COVERAGES_DETAIL_MEDIUM_DATA_REQUEST,
});

const coveragesAndPlansDetailsMediumSuccess = data => ({
    type: INSURANCE_REQUEST_RELATED_COVERAGES_DETAIL_MEDIUM_DATA_SUCCESS,
    data
});

const coveragesAndPlansDetailsHighInProgress = () => ({
    type: INSURANCE_REQUEST_RELATED_COVERAGES_DETAIL_HIGH_DATA_REQUEST,
});

const coveragesAndPlansDetailsHighSuccess = data => ({
    type: INSURANCE_REQUEST_RELATED_COVERAGES_DETAIL_HIGH_DATA_SUCCESS,
    data
});

const coveragesAndPlansDetailsFailure = error => ({
    type: INSURANCE_REQUEST_RELATED_COVERAGES_DETAIL_DATA_FAILURE,
    data: { error }
});

const selectPlanInRelatedWizardStep3 = insurancePlan => ({
    type: INSURANCE_REQUEST_RELATED_SELECTED_PLAN,
    data: {
        insurancePlan
    }
});

const linkClientSuccessInitialState = () => ({
    type: INSURANCE_REQUEST_RELATED_SIMULATION_LINK_S3_CLIENT_INITIAL_VALUE_IN_SUCCESS,
});

const basicPlanAcceptanceModal = () => ({
    type: INSURANCE_REQUEST_SELECT_BASIC_PLAN,
});

const linkClient = plan => (dispatch, getState) => {
    const {
        flagBasedFeatures,
        insuranceRequestModify,
        insuranceRequestRelatedState,
        insuranceRequestRelatedWizard,
    } = getState();

    const insuranceIsBeingModified = insuranceRequestModify.get('insuranceIsBeingModified');
    const isLinkingInProgress = insuranceRequestRelatedWizard.getIn(["steps", THIRD_STEP, "isLinkingInProgress"])

    if (!isLinkingInProgress) {
        dispatch(linkClientInProgress());

        const insuranceId = insuranceRequestRelatedWizard.getIn(["steps", THIRD_STEP, "quotationData", "idInsurance"]);
        const previousInsurance = insuranceIsBeingModified ? null : insuranceRequestRelatedState.getIn(['data', 'id']) || null;
        const expedientId = insuranceRequestRelatedState.get('idExpediente');
        const draft = insuranceIsBeingModified;
        const language = getLanguage().toUpperCase();

        let appraisal = false;
        let propertyId = null;

        if (insuranceRequestRelatedState.getIn(['appraisal', 'afterAppraisal'])) {
            const propertyMortgage = insuranceRequestRelatedState.getIn(['appraisal', 'property'])

            appraisal = insuranceRequestRelatedState.getIn(['appraisal', 'afterAppraisal']);
            propertyId = propertyMortgage.get('id');
        }

        const params = {
            query: {
                appraisal,
                draft,
                expedientId,
                insuranceId,
                language,
                plan,
                propertyId,
                previousInsurance
            }
        };

        if (flagBasedFeatures.get(PRE_CONTRACTUAL_RELATED_INSURANCE_MAIL)) {
            if (__CONTACT_CENTER__) {
                params['header'] = {
                    version: '3',
                }
            } else {
                params['header'] = {
                    version: '2',
                }
            }
        }

        const insuranceIdDraft = insuranceIsBeingModified ? insuranceId : null;

        return APIPost({
            dispatch,
            endpoint: 'insuranceRequestRelatedSimulationLinkClient',
            params
        })
            .then(() => {
                dispatch(mortgageRequestInsurancesLink(true, false));
                dispatch(linkClientSuccess());
                dispatch(requestInsuranceRelatedCurrentState(insuranceIdDraft));
            })
            .catch(response => {
                if (!!response.error) {
                    dispatch(linkClientFailure(response.error));
                } else {
                    throw response;
                }
            });
    } else {
        return Promise.resolve();
    }
};

const insuranceSelectPlan = plan => (dispatch, getState) => {
    const immStep = getState().insuranceRequestRelatedWizard.getIn(['steps', THIRD_STEP]);

    if (!immStep.get('isFetchingSelectPlan')) {
        dispatch(requestSelectPlanInProgress());
        const params = {
            query: {
                plan,
                simulationToken: immStep.getIn(['quotationData', 'simulationToken'])
            }
        };

        return APIPost({
            dispatch,
            endpoint: 'insuranceRequestSelectPlan',
            params
        })
            .then(dispatch(requestSelectPlanSuccess(plan)))
            .catch(response => {
                if (!!response.error) {
                    dispatch(requestSelectPlanFailure(response.error));
                } else {
                    throw response;
                }
            });
    } else {
        return Promise.resolve();
    }
};

const getCoveragesAndPlansData = (propertyUsage) => (dispatch, getState) => {
    dispatch(coveragesAndPlansDataInProgress());

    const immStep2 = getState().insuranceRequestRelatedWizard.getIn(['steps', SECOND_STEP]);
    const immStep3 = getState().insuranceRequestRelatedWizard.getIn(['steps', THIRD_STEP]);

    const params = {
        query: {
            homeInsuranceType: HOME_MORTGAGE_RELATED,
            propertyCharacter: immStep2.get('propertyCharacter'),
            propertyUsage,
            simulationToken: immStep3.getIn(['quotationData', 'simulationToken'])
        }
    };

    return APIGet({
        dispatch,
        endpoint: 'insuranceRequestCoveragesAndPlans',
        params
    })
        .then(response => {
            dispatch(coveragesAndPlansDataSuccess(response.data));
        })
        .catch(response => {
            if (!!response.error) {
                dispatch(coveragesAndPlansDataFailure(response.error));
            }
        })
};

const getCoveragesAndPlansDetailsData = (usage, character, plan = HIGH) => (dispatch, getState) => {
    const immFlagBasedFeatures = getState().flagBasedFeatures;

    const nextPlan = plan === HIGH ? MEDIUM : BASIC;
    const immStep3 = getState().insuranceRequestRelatedWizard.getIn(['steps', THIRD_STEP]);
    const simulationToken = immStep3.getIn(['quotationData', 'simulationToken']);
    const actions = {
        HIGH: {
            inProgress: coveragesAndPlansDetailsHighInProgress,
            success: coveragesAndPlansDetailsHighSuccess
        },
        MEDIUM: {
            inProgress: coveragesAndPlansDetailsMediumInProgress,
            success: coveragesAndPlansDetailsMediumSuccess
        },
        BASIC: {
            inProgress: coveragesAndPlansDetailsBasicInProgress,
            success: coveragesAndPlansDetailsBasicSuccess
        }
    };

    dispatch(actions[plan].inProgress());
    const params = {
        query: {
            propertyUsage: usage,
            insurancePlan: plan,
            propertyCharacter: character,
            homeInsuranceType: HOME_MORTGAGE_RELATED,
            simulationToken
        }
    };

    if (immFlagBasedFeatures.get(INSURANCE_USABILITY_IMPROVEMENTS)) {
        params['header'] = {
            version: '2',
        }
    }
    
    return APIGet({
        dispatch,
        endpoint: 'insuranceRequestCoveragesAndPlansDetails',
        params
    })
        .then(response => {
            dispatch(actions[plan].success(response.data));
            if (nextPlan !== plan) {
                dispatch(getCoveragesAndPlansDetailsData(usage, character, nextPlan));
            }
        })
        .catch(response => {
            if (!!response.error) {
                dispatch(coveragesAndPlansDetailsFailure(response.error));
            } else {
                throw response;
            }
        });
};

const getPopulationLabel = immStep2 => {
    const populationValue = immStep2.get('populationValue');
    if (populationValue) {
        const immPopulation = immStep2.get('populationOptions').
            find(immPopulation => populationValue === immPopulation.get('value'));
        return !!immPopulation && immPopulation.get('label');
    }
}

const getQuotationData = hasSimulationChanged => (dispatch, getState) => {
    const { insuranceRequestRelatedState, insuranceRequestRelatedWizard } = getState();
    const immStep2 = insuranceRequestRelatedWizard.getIn(['steps', SECOND_STEP]);
    const immStep3 = insuranceRequestRelatedWizard.getIn(['steps', THIRD_STEP]);
    const expedientId = insuranceRequestRelatedState.get('idExpediente');
    const afterAppraisal = insuranceRequestRelatedState.getIn(['appraisal', 'afterAppraisal']);
    const appraisalSize = insuranceRequestRelatedState.getIn(['appraisal', 'property', 'appraisalSize']);

    const populationLabel = getPopulationLabel(immStep2);
    const params = {
        query: {
            continent: immStep2.get('continent'),
            content: immStep2.get('content'),
            postalCode: immStep2.get('postalCode'),
            population: populationLabel,
            propertyCharacter: immStep2.get('propertyCharacter'),
            propertyType: immStep2.get('propertyType'),
            propertyUsage: immStep2.get('propertyUsage'),
            size: afterAppraisal ? appraisalSize || 0 : immStep2.get('size'),
            relatedInformation: {
                appraisal: false,
                expedientId,
                insuranceId: null,
                propertyId: null
            },
        }
    };

    if (
        !!insuranceRequestRelatedState && afterAppraisal
    ) {
        const propertyMortgage = insuranceRequestRelatedState.getIn(['appraisal', 'property'])
        const propertyMortgageId = propertyMortgage.get("id")
        params.query.relatedInformation.appraisal = true;
        params.query.relatedInformation.propertyId = propertyMortgageId;
    }

    if (__CONTACT_CENTER__) {
        const selectedPlan = immStep3.get('insurancePlan');

        if (!!selectedPlan && !immStep3.get('coveragePlanModal').isEmpty() && immStep3.get('isQuotationDataChanged')) {
            const planCoverages = immStep3.getIn(['coveragePlanModal', selectedPlan.toUpperCase()]);
            const coveragesWithChanges = planCoverages.filter(coverage => coverage.get('hasChanged') || coverage.get('changed'));
            let fields = {};

            coveragesWithChanges.forEach(coverage => {
                if (coverage.get('hasChanged')) {
                    fields[COVERAGES_NAMES[coverage.get('name')]] = coveragesWithChanges.get(coverage.get('name')).get('currentValue');
                } else if (coverage.get('changed')) {
                    fields[COVERAGES_NAMES[coverage.get('name')]] = coveragesWithChanges.get(coverage.get('name')).get('defaultValue');
                }
            });

            params.query.guaranteeInformation = {
                ...fields
            };
        }
    }

    const quotationRequestId = Math.random()
    dispatch(requestQuotationInProgress(quotationRequestId));

    return APIPost({
        dispatch,
        endpoint: 'insuranceRequestRelatedQuotation',
        params
    })
        .then(response => {
            const insuranceRequestRelatedWizardUpdate = getState().insuranceRequestRelatedWizard
            const stateQuotationRequestId = insuranceRequestRelatedWizardUpdate.getIn(['steps', THIRD_STEP, 'quotationRequestId'])

            if (quotationRequestId === stateQuotationRequestId) {

                dispatch(requestQuotationSuccess(response.data));

                if (__CONTACT_CENTER__) {
                    dispatch(getCoveragesAndPlansData(immStep2.get('propertyUsage')));
                    dispatch(getCoveragesAndPlansDetailsData(immStep2.get('propertyUsage'), immStep2.get('propertyCharacter')))
                }

                if (immStep3.get('insurancePlan')) {
                    if (hasSimulationChanged) {
                        dispatch(requestSelectPlanSuccess(''));
                    }
                }
            }
        })
        .catch(response => {
            if (!!response.error) {
                dispatch(requestQuotationFailure(response.error));
            } else {
                throw response;
            }
        });
};

module.exports = {
    basicPlanAcceptanceModal,
    linkClient,
    getQuotationData,
    insuranceSelectPlan,
    getCoveragesAndPlansData,
    getCoveragesAndPlansDetailsData,
    selectPlanInRelatedWizardStep3,
    setLinkedSimulationToInitial,
    linkClientSuccessInitialState,
};
